import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon55: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#FFD147"
        d="M8.538.026c2.82.269 4.962 2.779 4.962 5.689v4.284h.491c1.059 0 1.927.819 2.003 1.859l.006.149v4.019a3.973 3.973 0 0 1-3.973 3.973H3.973A3.973 3.973 0 0 1 0 16.026v-4.02C0 10.899.9 10 2.009 10H2.5v-4.5A5.501 5.501 0 0 1 8.538.027Zm5.453 10.973H2.009A1.01 1.01 0 0 0 1 12.007v4.019a2.973 2.973 0 0 0 2.973 2.973h8.054A2.973 2.973 0 0 0 15 16.026v-4.02A1.01 1.01 0 0 0 13.991 11ZM8.5 14.997a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm-3 0a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm6 0a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1ZM3.5 5.5v4.499h1V5.494A3.5 3.5 0 0 1 7.808 2L8 1.994a3.5 3.5 0 0 1 3.5 3.5v4.505h1V5.715c0-2.335-1.659-4.35-3.849-4.67l-.207-.024A4.502 4.502 0 0 0 3.5 5.5ZM8 2.994a2.5 2.5 0 0 0-2.5 2.5v4.505h5V5.494A2.499 2.499 0 0 0 8.164 3L8 2.994Z"
      />
    </Svg>
  )
}
